const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'User',
        dataIndex: 'userDetails',
        render: defaultRender,
        fixed: "left"
    },
    {
        title: 'Mobile No',
        dataIndex: 'phoneNo',
        render: defaultRender,
    },
    {
        title: 'User Type',
        dataIndex: 'userType',
        render: defaultRender,
    },
    {
        title: 'Parent',
        dataIndex: 'parentName',
        render: defaultRender,
        // sorter: (a, b) => a?.parentName?.localeCompare(b?.parentName),
    },
    {
        title: 'Referral Code',
        dataIndex: 'referralCode',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    // {
    //     title: 'T&C',
    //     dataIndex: 'tnc',
    //     render: defaultRender,
    // },
];

export default columns;